:host {
  width: 100%;
  display: block;
  margin-bottom: var(--cms-spacing-075);
  @include cms-base-font-100;
}

.content-tag {
  display: inline-block;
  padding: var(--cms-spacing-050);
  margin: var(--cms-spacing-025) var(--cms-spacing-025) var(--cms-spacing-025) 0;
  background: var(--cms-semanticColors-base-strong-background);
  font-weight: var(--cms-heading-base-font-weight);
}

.content-tag-link {
  display: block;
  font-family: var(--cms-brandfont2);
  color: var(--cms-semanticColors-base-strong-textOnBackground);
  text-decoration: none;
  padding: var(--cms-spacing-025);
}